(function () {
  function initSupportRoot(root) {
    if (!root || root.dataset.navReady === 'true') return;
    root.dataset.navReady = 'true';

    const views = root.querySelectorAll('[data-fp-support-view]');
    const dialog = root.closest('.fp-support-modal__dialog, .fp-hu-modal__dialog');

    function showView(name) {
      views.forEach(function (view) {
        const match = view.getAttribute('data-fp-support-view') === name;
        view.classList.toggle('is-active', match);
        view.toggleAttribute('hidden', !match);
      });
      if (dialog) {
        dialog.classList.toggle('is-detail', name !== 'home');
      }
      root.setAttribute('data-fp-support-current', name);
      const active = root.querySelector('[data-fp-support-view="' + name + '"]');
      if (active) {
        active.scrollTop = 0;
        const focusable = active.querySelector('.fp-support__back, input, textarea, select, button');
        if (focusable) focusable.focus({ preventScroll: true });
      }
    }

    root.addEventListener('click', function (event) {
      const go = event.target.closest('[data-fp-support-go]');
      if (go && root.contains(go)) {
        event.preventDefault();
        showView(go.getAttribute('data-fp-support-go'));
        return;
      }
      const back = event.target.closest('[data-fp-support-back]');
      if (back && root.contains(back)) {
        event.preventDefault();
        showView('home');
      }
    });

    root.resetToHome = function () {
      showView('home');
    };
  }

  function initAll() {
    document.querySelectorAll('[data-fp-support-root]').forEach(initSupportRoot);
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);

  // When support modal opens, reset to home list
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      const modal = m.target;
      if (!modal || !modal.hasAttribute || !modal.hasAttribute('data-fp-support-modal')) return;
      if (!modal.hasAttribute('hidden')) {
        const root = modal.querySelector('[data-fp-support-root]');
        if (root && typeof root.resetToHome === 'function') root.resetToHome();
        else if (root) {
          root.querySelectorAll('[data-fp-support-view]').forEach(function (view) {
            const home = view.getAttribute('data-fp-support-view') === 'home';
            view.classList.toggle('is-active', home);
            view.toggleAttribute('hidden', !home);
          });
        }
      }
    });
  });

  document.querySelectorAll('[data-fp-support-modal]').forEach(function (modal) {
    observer.observe(modal, { attributes: true, attributeFilter: ['hidden'] });
  });
})();
